import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  modalContents: {
    width: "min(300px, 80vw)",
    padding: 16,
    borderRadius: 16,
    paddingTop: 32,
  },
  modalActions: {
    [theme.breakpoints.down("md")]: {
      justifyContent: "space-between",
    },
  },
}));
